/**
 * Os ícones da tela, como SVG inline.
 *
 * Sem biblioteca de ícones de propósito: são poucos, e uma dependência de runtime para
 * dez traços é peso que o gate de licenças do `F-05` teria que auditar sem ganhar nada.
 * Todos herdam `currentColor`, então a cor vem de quem os usa — que é como o §1 quer:
 * a cor é significado, e o significado é do contexto, não do desenho.
 */
const PADRAO = {
  width: 16,
  height: 16,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.8,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
  "aria-hidden": true,
};

export const Icone = {
  Menu: () => (
    <svg {...PADRAO}>
      <path d="M4 7h16M4 12h16M4 17h16" />
    </svg>
  ),
  Fechar: () => (
    <svg {...PADRAO}>
      <path d="M6 6l12 12M18 6L6 18" />
    </svg>
  ),
  Lista: () => (
    <svg {...PADRAO}>
      <path d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01" />
    </svg>
  ),
  Relogio: () => (
    <svg {...PADRAO}>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3 2" />
    </svg>
  ),
  Alerta: () => (
    <svg {...PADRAO}>
      <path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z" />
      <path d="M12 9v4M12 17h.01" />
    </svg>
  ),
  Escudo: () => (
    <svg {...PADRAO}>
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z" />
      <path d="m9 12 2 2 4-4" />
    </svg>
  ),
  Dinheiro: () => (
    <svg {...PADRAO}>
      <rect x="2" y="6" width="20" height="12" rx="2" />
      <circle cx="12" cy="12" r="2.5" />
      <path d="M6 12h.01M18 12h.01" />
    </svg>
  ),
  Barrado: () => (
    <svg {...PADRAO}>
      <circle cx="12" cy="12" r="9" />
      <path d="m5.6 5.6 12.8 12.8" />
    </svg>
  ),
  Busca: () => (
    <svg {...PADRAO}>
      <circle cx="11" cy="11" r="7" />
      <path d="m20 20-3.5-3.5" />
    </svg>
  ),
  Recarga: () => (
    <svg {...PADRAO}>
      <path d="M21 12a9 9 0 1 1-3-6.7" />
      <path d="M21 3v6h-6" />
    </svg>
  ),
  Alvo: () => (
    <svg {...PADRAO} width={20} height={20}>
      <circle cx="12" cy="12" r="9" />
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v3M12 19v3M2 12h3M19 12h3" />
    </svg>
  ),
  Enviar: () => (
    <svg {...PADRAO}>
      <path d="m22 2-7 20-4-9-9-4Z" />
    </svg>
  ),
  Engrenagem: () => (
    <svg {...PADRAO}>
      <circle cx="12" cy="12" r="3.2" />
      <path d="M19.4 14.5a1.7 1.7 0 0 0 .3 1.9l.1.1a2 2 0 1 1-2.9 2.9l-.1-.1a1.7 1.7 0 0 0-1.9-.3 1.7 1.7 0 0 0-1 1.5v.2a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.6 1.7 1.7 0 0 0-1.9.3l-.1.1a2 2 0 1 1-2.9-2.9l.1-.1a1.7 1.7 0 0 0 .3-1.9 1.7 1.7 0 0 0-1.5-1H2.6a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.6-1.1 1.7 1.7 0 0 0-.3-1.9l-.1-.1a2 2 0 1 1 2.9-2.9l.1.1a1.7 1.7 0 0 0 1.9.3h.1A1.7 1.7 0 0 0 10 3.5v-.2a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.9-.3l.1-.1a2 2 0 1 1 2.9 2.9l-.1.1a1.7 1.7 0 0 0-.3 1.9v.1a1.7 1.7 0 0 0 1.5 1h.2a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.6 1Z" />
    </svg>
  ),
  Foto: () => (
    <svg {...PADRAO}>
      <rect x="2.5" y="4.5" width="19" height="15" rx="2" />
      <circle cx="8.5" cy="10" r="1.8" />
      <path d="m3 17 5-4.5 4 3.5 3-2.5 6 5" />
    </svg>
  ),
  Grafico: () => (
    <svg {...PADRAO}>
      <path d="M3 21h18" />
      <path d="M6 21V11M11 21V4M16 21v-7M21 21v-5" />
    </svg>
  ),
  Conversa: () => (
    <svg {...PADRAO}>
      <path d="M21 12a8 8 0 0 1-11.6 7.1L4 20l1-4.6A8 8 0 1 1 21 12Z" />
      <path d="M8.5 12h.01M12 12h.01M15.5 12h.01" />
    </svg>
  ),
  Duvida: () => (
    <svg {...PADRAO}>
      <circle cx="12" cy="12" r="9" />
      <path d="M9.6 9.3a2.5 2.5 0 1 1 3.3 2.4c-.6.2-.9.8-.9 1.4v.4M12 17h.01" />
    </svg>
  ),
  Pessoas: () => (
    <svg {...PADRAO}>
      <circle cx="9" cy="8" r="3.2" />
      <path d="M2.5 20a6.5 6.5 0 0 1 13 0" />
      <path d="M16.5 5.2a3.2 3.2 0 0 1 0 5.6M18 14.6a6.5 6.5 0 0 1 3.5 5.4" />
    </svg>
  ),
  Chave: () => (
    <svg {...PADRAO}>
      <circle cx="7.5" cy="16.5" r="3.5" />
      <path d="m10 14 8.5-8.5M16 8l2 2M19 5l2 2" />
    </svg>
  ),
  Seta: () => (
    <svg {...PADRAO} width={14} height={14}>
      <path d="m9 6 6 6-6 6" />
    </svg>
  ),
  Baixar: () => (
    <svg {...PADRAO}>
      <path d="M12 3v12M7 11l5 4 5-4M4 21h16" />
    </svg>
  ),
  Subir: () => (
    <svg {...PADRAO}>
      <path d="M12 21V9M7 13l5-4 5 4M4 3h16" />
    </svg>
  ),
  Certo: () => (
    <svg {...PADRAO}>
      <path d="m5 12 5 5L20 7" />
    </svg>
  ),
  Nota: () => (
    <svg {...PADRAO}>
      <path d="M4 4h16v12l-4 4H4Z" />
      <path d="M16 20v-4h4M8 9h8M8 13h5" />
    </svg>
  ),
  Lupa: () => (
    <svg {...PADRAO}>
      <circle cx="11" cy="11" r="7" />
      <path d="m21 21-4.3-4.3M11 8v6M8 11h6" />
    </svg>
  ),
  Expandir: () => (
    <svg {...PADRAO}>
      <path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5" />
    </svg>
  ),
  Lapis: () => (
    <svg {...PADRAO}>
      <path d="M4 20h4L19 9l-4-4L4 16Z" />
      <path d="m13.5 6.5 4 4" />
    </svg>
  ),
  // Os três do seletor de tema (`C-19`).
  Lua: () => (
    <svg {...PADRAO}>
      <path d="M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5Z" />
    </svg>
  ),
  Sol: () => (
    <svg {...PADRAO}>
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
    </svg>
  ),
  Monitor: () => (
    <svg {...PADRAO}>
      <rect x="3" y="4" width="18" height="12" rx="2" />
      <path d="M8 20h8M12 16v4" />
    </svg>
  ),
};
